import { Card } from 'react-bootstrap';

function StudentHome() {
  return (
    <Card className="shadow-sm p-4">
      <h4>Student Dashboard</h4>
      <p>Welcome to your student dashboard. You can check assignments and progress reports here.</p>
    </Card>
  );
}

export default StudentHome;
